/**
 * Texte de confirmation avant publication d'une quête (décisions D3 et Q8).
 * L'admin relit le prix qu'il s'apprête à engager : publier notifie les
 * Spotters, et le client pour une mission client. Le serveur refuse de toute
 * façon un prix à 0 ; ce texte sert à ne pas publier un prix non relu.
 */
export interface PrixQuete {
  titre?: string;
  tokensBase?: number | null;
  budgetClient?: number | null;
  source?: string | null;
}

const fr = (n: number) => n.toLocaleString("fr-FR");

export function estMissionClient(q: PrixQuete): boolean {
  return q.source === "client_ia";
}

export function texteConfirmationPublication(q: PrixQuete): string {
  const tips = Number(q.tokensBase) || 0;
  const budget = Number(q.budgetClient) || 0;
  const prix = `Tips par collecte : ${tips > 0 ? fr(tips) : "non renseigné"}. `
    + `Budget client : ${budget > 0 ? `${fr(budget)} F CFA` : "non renseigné"}.`;
  const qui = estMissionClient(q)
    ? "La publication notifie les Spotters et le client."
    : "La publication notifie les Spotters.";
  return `Valider et publier${q.titre ? ` « ${q.titre} »` : ""} ? ${prix} ${qui}`;
}

/** Statut « archivee » (Q9) : quête clôturée, plus visible des Spotters. */
export function estArchivee(statut?: string | null): boolean {
  return (statut ?? "").toLowerCase() === "archivee";
}
